/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const FormWrapper: ({ title, childern, description, titleLink, addMore, addMoreLabel, customClass }: {
    title?: string | React.ReactNode;
    childern: any;
    description?: string | any;
    titleLink?: string;
    addMore?: any;
    addMoreLabel?: any;
    customClass?: string;
    subHeading?: string;
}) => React.JSX.Element = ({ title, childern, description, titleLink, addMore, addMoreLabel, customClass, subHeading }) => {
    const hasHeaderContent = title || description || subHeading || addMore;
    return (
        <div className={`font-manrope space-y-2  ${customClass}`}>
            {hasHeaderContent && (
            <div className="flex md:flex-col justify-between items-center gap-2">
                <div className="w-full space-y-1 mb-2">
                    {!!title && (<h2 className="text-[2.5vh] font-manropeSB flex items-baseline gap-2">{title}{" "} {!!titleLink && <a href="#" className="font-manropeB tracking-wide text-purple-primary underline text-[1.8vh]">{titleLink}</a>}</h2>)}
                    {!!description && typeof(description) === "string" && (<p className="text-[2vh] text-gray-500">{description}</p>)}
                    {!!description && typeof(description) !== "string" && description}
                    {!!subHeading && <p className="text-[1.8vh] text-gray-400 font-light m  t-1">{subHeading}</p>}
                </div>
                {!!addMore && <button
                    onClick={addMore}
                    className="w-fit py-2 px-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-medium"
                    style={{ color: "#fff" }}
                    type="button"
                >
                    {addMoreLabel}
                </button>}

            </div>
            )}
            {childern}
        </div>
    );
};

export default FormWrapper;
